<template>
    <vx-tooltip :text="isScreened ? 'Envía la solicitud a riesgo crediticio para su aprobación' : 'Regresa la solicitud a originación para su revisión'">
        <vs-button @click.stop="requestUpdateLoan()" size="small" color="danger" type="filled" >
            {{ isScreened ? 'Enviar a riesgo' : 'Regresar a originación' }}
        </vs-button>
    </vx-tooltip>
</template>

<script>
import { method } from 'lodash';

export default {
    data: () => ({
        
    }),
    props: {
        loanId: {
            type: (Number, String),
            required: true
        },
        isScreened: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        requestUpdateLoan() {
            this.$vs.dialog({
                type: 'confirm',
                color: 'warning',
                title: this.isScreened ? 'Enviar a riesgo' : 'Regresar a originación',
                text: `¿Estás seguro que deseas ${this.isScreened ? 'enviar la solicitud a riesgo crediticio' : 'regresar la solicitud a originación'}?`,
                acceptText: this.isScreened ? "Enviar a riesgo" : "Regresar a originación",
                cancelText: 'Cancelar',
                accept: () => {
                    this.updateLoanDate();
                }
            });
        },
        async updateLoanDate() {
            try {
                this.showLoading(true);
                const res = await axios.put("/api/project/put/application-screened", {
                    id: this.loanId,
                    isScreened: this.isScreened ? 1 : 0
                });
                this.$emit('on-save');
                this.showLoading(false);
                this.saveSuccessNotif();
            } catch (error) {
                console.error("Error updating loan date:", error);
                this.showLoading(false);
            }
            this.showLoading(false);
        },
    }
}
</script>